/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / Typescript / React / Angular / Vue
 * @version v27.0.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
export var ClientSideRowModelSteps;
(function (ClientSideRowModelSteps) {
    ClientSideRowModelSteps["EVERYTHING"] = "group";
    ClientSideRowModelSteps["FILTER"] = "filter";
    ClientSideRowModelSteps["SORT"] = "sort";
    ClientSideRowModelSteps["MAP"] = "map";
    ClientSideRowModelSteps["AGGREGATE"] = "aggregate";
    ClientSideRowModelSteps["PIVOT"] = "pivot";
    ClientSideRowModelSteps["NOTHING"] = "nothing";
})(ClientSideRowModelSteps || (ClientSideRowModelSteps = {}));
